import { render } from "./PriceListPdf.vue?vue&type=template&id=57536dde&scoped=true"
import script from "./PriceListPdf.vue?vue&type=script&lang=js"
export * from "./PriceListPdf.vue?vue&type=script&lang=js"

import "./PriceListPdf.vue?vue&type=style&index=0&id=57536dde&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57536dde"]])

export default __exports__